import { Box, Typography } from "@mui/material";
import React from "react";

type MultiLineCellProps = {
  lines: (string | React.ReactNode | null | undefined)[];
};

export const MultiLineCell: React.FC<MultiLineCellProps> = ({ lines }) => {
  return (
    <Box
      sx={{
        width: "100%",
        overflow: "hidden",
      }}
    >
      {lines?.map((line, index) => {
        if (!line) {
          return null;
        }
        if (React.isValidElement(line)) {
          return <React.Fragment key={index}>{line}</React.Fragment>;
        }
        return (
          <Typography key={index} variant="body2" noWrap>
            {line}
          </Typography>
        );
      })}
    </Box>
  );
};
